import React, { useState } from "react";
import "./ContactForm.css";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    item: "Select an Item",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const phoneNumber = "+923055808021";
    const text = `
Name: ${formData.name}
Email/Company: ${formData.email}
Phone: ${formData.phone}
Selected Item: ${formData.item}
Message: ${formData.message}
    `.trim();

    const encodedText = encodeURIComponent(text);
    window.open(`https://wa.me/${phoneNumber}?text=${encodedText}`, "_blank");
  };

  return (
    <div className="contact-form-card">
      <h3>Contact Form</h3>
      <p className="form-subtitle">Get in touch with us via WhatsApp</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <input
            type="email"
            name="email"
            placeholder="Email / Company Name"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <select
            name="item"
            value={formData.item}
            onChange={handleChange}
            required
          >
            <option value="Select an Item">Select an Item</option>
            <option value="Grains">Grains</option>
            <option value="Frozen Meat">Frozen Meat</option>
            <option value="Others">Other Specialtites</option>
          </select>
        </div>

        <div className="form-group">
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="4"
          ></textarea>
        </div>

        <div className="captcha-row">
          <input type="checkbox" id="captcha" required />
          <label htmlFor="captcha">I'm not a robot</label>
        </div>

        <button type="submit" className="submit-btn">
          Send Your Inquiry via WhatsApp
        </button>
      </form>
    </div>
  );
}
